// GA4 へのイベント送信。計測が有効かどうかはレイアウトが測定 ID を meta タグへ
// 出力しているかで決まり、無効なページでは送信経路自体を作らないため外部送信は発生しない。
// 画像・入力文字列・ファイル名は送らない（端末内処理の約束を計測でも守る）ため、
// パラメータには列挙値とコード定義の固定 ID だけを渡すこと。

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export type EventParams = Record<string, string | number>;

export interface Tracker {
  /** ページビュー計測を開始する（gtag.js の js / config コマンド） */
  startPageTracking(): void;
  track(name: string, params?: EventParams): void;
}

const noopTracker: Tracker = {
  startPageTracking() {},
  track() {},
};

export function createTracker(measurementId: string | null, dataLayer: unknown[]): Tracker {
  if (!measurementId) return noopTracker;

  // gtag.js は dataLayer に配列ではなく Arguments オブジェクトが積まれている前提で動く。
  // rest 引数を配列として push すると gtag.js が解釈せず、送信されないまま溜まる
  const gtag = function (..._args: unknown[]): void {
    dataLayer.push(arguments);
  };

  return {
    startPageTracking() {
      gtag("js", new Date());
      gtag("config", measurementId);
    },
    track(name, params) {
      if (params) gtag("event", name, params);
      else gtag("event", name);
    },
  };
}

export function browserTracker(): Tracker {
  const measurementId =
    document.querySelector('meta[name="ga-measurement-id"]')?.getAttribute("content") ?? null;
  if (!measurementId) return noopTracker;
  window.dataLayer ??= [];
  return createTracker(measurementId, window.dataLayer);
}
